/**
 * The custom range edits local time (the viewer's zone) and the URL holds UTC.
 * These two convert between a `datetime-local` input's value and an ISO instant.
 */

const pad = (value: number) => String(value).padStart(2, '0');

export function toLocalInput(iso: string): string {
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return '';
    const ms = date.getMilliseconds();
    return (
        `${String(date.getFullYear())}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}` +
        `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}` +
        // Seconds alone already round-trips every boundary this screen produces
        // itself (a preset, or "Refresh"); milliseconds are kept too so a
        // non-`:00` instant — any alert deep-link — survives opening the
        // custom range and applying it unchanged, rather than shifting by up
        // to 59.999s. The widget has no millisecond step, so this never shows;
        // it only changes what round-trips.
        (ms === 0 ? '' : `.${String(ms).padStart(3, '0')}`)
    );
}

export function fromLocalInput(value: string): string | undefined {
    if (value.trim() === '') return undefined;
    // A `datetime-local` value has no zone, which `Date` reads as local time.
    const time = new Date(value).getTime();
    return Number.isNaN(time) ? undefined : new Date(time).toISOString();
}
